import PropTypes from 'prop-types';

/**
 * Shape of a flat Pro Sound Effects sound effect (see GraphQL `SoundEffect` type).
 *
 * Kept in its own module so both the row and its action bar can import it without creating a
 * circular dependency (SoundEffect ↔ SoundEffectButtonBar).
 */
export const SoundEffectPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  category: PropTypes.string,
  subCategory: PropTypes.string,
  duration: PropTypes.number.isRequired,
  previewUrl: PropTypes.string,
  waveformDataUrl: PropTypes.string,
  waveformImageUrl: PropTypes.string,
  artworkUrl: PropTypes.string,
  downloadUrl: PropTypes.string.isRequired,
});

/**
 * TypeScript counterpart of {@link SoundEffectPropType}, consumed by the row, its action bar and
 * the result list. Nullable URL fields mirror the GraphQL payload (the key is always present, its
 * value may be `null`).
 */
export interface SoundEffectData {
  id: string
  title: string
  description?: string | null
  category?: string | null
  subCategory?: string | null
  duration: number
  previewUrl: string | null
  waveformDataUrl: string | null
  waveformImageUrl: string | null
  artworkUrl?: string | null
  /** Relative path to the Miooz protected download route, provided by the API (see GraphQL `SoundEffect.downloadUrl`). */
  downloadUrl: string
}
